import is from 'is_js';

export default class RT {
  constructor(result) {
    if (result) {
      if (result.data) {
        const d = result.data;
        const dd = result.data.data;
        if (
          is.object(dd) &&
          'id' in dd &&
          'code' in dd &&
          'data' in dd &&
          'message' in dd &&
          'description' in dd
        ) {
          this.id = dd.id;
          this.code = dd.code;
          this.data = dd.data;
          this.message = dd.message;
          this.description = dd.description;
        } else {
          this.id = d.id;
          this.message = d.message;
          this.code = d.code;
          this.data = d.data;
          this.description = d.description;
        }
        //Get token from header set to rt and rt.data.
        if (result.headers && result.headers.token) {
          this.token = result.headers.token;
          if (is.object(this.data)) {
            this.data.token = this.token;
          }
        }
      } else {
        this.id =
          result.id != null && result.id != undefined ? result.id : 69999;
        this.code = result.name;
        this.message = result.message;
        this.description = result.description
          ? result.description
          : result.cause; //Where is cause
      }
    } else {
      this.id = 0;
    }
  }

  isOk() {
    return this.id === 0;
  }
  isNotOk() {
    return this.id != 0;
  }
  isCancel() {
    return this.id === 60007;
  }
  isToReLogin() {
    console.log('Check re-login for code', this.id);
    return this.id == 60000 || this.id == 60003 || this.id == 60031;
  }
}
